import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi"; // Using Feather icons from react-icons

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-[#f7f7f7] max-w-6xl mx-auto relative z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between  items-center">
        {/* Logo */}
        <div>
          <Link to="/">
            <img src="/logo.png" alt="Minterminds Logo" className="h-8 md:h-10" />
          </Link>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-8 font-medium text-[#878181]">
          <Link to="/teams" className="hover:text-primary">Team</Link>
          <Link to="/portfolio" className="hover:text-primary">Portfolio</Link>
          <Link to="/blogs" className="hover:text-primary">Blog</Link>
          <Link to="/contact" className="hover:text-primary">Contact</Link>
          <Link to="/template" className="hover:text-primary">Templates</Link>

        </nav>

        {/* Chat Button (visible on all screens) */}
        <div className="flex items-center space-x-4">
          <a
            href="https://wa.me/639758578476?text=Hi%2C%20I%20want%20to%20know%20more%20about%20your%20services"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#3087b7] px-4 py-3 rounded-lg text-[#fff] font-semibold"
          >
            Chat with us
          </a>
          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>


      </div>

      {/* Mobile Dropdown Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white px-4  pt-4 pb-4 bg-[#f4f4f4] border-t border-b border-[#ccc] space-y-4">
          <Link to="/teams" className="block text-[#333] hover:text-primary">Team</Link>
          <Link to="/portfolio" className="block text-[#333] hover:text-primary">Portfolio</Link>
          <Link to="/blogs" className="block text-[#333] hover:text-primary">Blog</Link>
          <Link to="/contact" className="block text-[#333] hover:text-primary">Contact</Link>
          <Link to="/template" className="block text-[#333] hover:text-primary">Templates</Link>



        </div>
      )}
    </header>
  );
};

export default Header;
